// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"37880c18","473":"5134c96f","486":"8b53c02b","568":"31cc9065","590":"07ab2732","621":"5f7358ef"}[chunkId] + ".chunk.js";
};